import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import { useFormCreateMileages } from '../../controllers/Mileages/CreateMileagesController';
import LoadingScreen from '../../components/LoadingScreen';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

const MileageForm: React.FC = () => {
    const { getMileageFormController, handleMileageFormController } = useFormCreateMileages();
    const history = useHistory();

    const [registerFinished, setRegisterFinished] = useState(false);

    useEffect(() => {
        if (getMileageFormController.mileageResponse?.status === 200) {
            setRegisterFinished(true);
        }
        if (getMileageFormController.mileageEditedResponse?.status === 200 && !getMileageFormController.mileageResponse) {
            setRegisterFinished(false);
        }
    }, [getMileageFormController.mileageResponse, getMileageFormController.mileageEditedResponse]);

    return (
        <div style={{ height: '100%' }} className="p-grid p-align-center p-justify-center">
            <Toast ref={getMileageFormController.toast} />
            {getMileageFormController.loading ? <LoadingScreen color="#0388e5" /> : <></>}
            <div className="p-col-12 p-md-8">
                <div className="card p-fluid">
                    <h5>Tipo de quilometragem</h5>
                    <div className="p-field">
                        <label htmlFor="name">Nome</label>
                        <InputText id="name" type="text" maxLength={150} disabled={registerFinished}
                            value={getMileageFormController.formik.values.DESCRICAO}
                            onChange={getMileageFormController.formik.handleChange('DESCRICAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getMileageFormController.formik.touched.DESCRICAO && getMileageFormController.formik.errors.DESCRICAO,
                            'popup-form-inactive': !(getMileageFormController.formik.touched.DESCRICAO && getMileageFormController.formik.errors.DESCRICAO),
                        })}
                        >{getMileageFormController.formik.errors.DESCRICAO}</div>
                    </div>
                    <div className="p-fluid p-grid p-justify-between">
                        {getMileageFormController.mileageResponse?.status === 200 && !registerFinished ?
                            <div className="p-col-12 p-md-4">
                                <Button
                                    type="button"
                                    label="Salvar Alterações"
                                    onClick={() => {
                                        getMileageFormController.formik.handleSubmit()
                                    }}
                                />
                            </div> :
                            getMileageFormController.mileageResponse?.status === 200 && registerFinished ?
                                <div className="p-col-12 p-md-6 p-fluid p-grid" >
                                    <div className="p-col-12 p-md-5">
                                        <Button
                                            type="button"
                                            label="Editar"
                                            onClick={() => {
                                                setRegisterFinished(false);
                                            }}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-5" >
                                        <Button
                                            icon="pi pi-plus"
                                            type="button"
                                            className="p-button-success"
                                            label="Cadastrar novo"
                                            onClick={() => {
                                                getMileageFormController.formik.resetForm();
                                                setRegisterFinished(false);
                                                handleMileageFormController.setMileageResponse(null);
                                            }}
                                        />
                                    </div>
                                </div> :
                                <div className="p-col-12 p-md-4">
                                    <Button
                                        type="button"
                                        label="Cadastrar"
                                        onClick={() => getMileageFormController.formik.handleSubmit()}
                                    />
                                </div>
                        }

                        <div className="p-col-12 p-md-4">
                            <Button
                                type="button"
                                className="p-button-secondary"
                                label="Voltar para listagem"
                                onClick={() => history.goBack()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default MileageForm;